import { Button } from "@mantine/core";
import { Dialog, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IUserFineView } from "../../_common/interface/userFine/iUserFineView";
import { PrimaryButton } from "../../_components/button/primary.button";
import { getMoneyFormat } from "../../_helpers/format.helper";
import { userFineService } from "../../_services/userFineService.service";


export function UserProfileFineView() {
    const resetData = () => ({
        id: 0,
        name: '',
        description: '',
        price: 0.00,
        durationBan: null,
        isChargeable: true,
        isBannedIndefinitely: false,
        isPaid: false
    });
    const navigate = useNavigate();
    const { userId, fineId } = useParams<{ userId: string, fineId: string }>();

    const [data, setData] = useState<IUserFineView>(resetData);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (!!fineId)
            fetchData();
        else
            setData(resetData);
    }, [fineId]);

    function fetchData() {
        if (!fineId) return;
        setLoading(true);
        return userFineService
            .get(Number(fineId))
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }


    return (
        <>
            <Dialog open={true} fullWidth>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        Fine Name: {data.name}
                    </Grid>
                    <Grid item xs={12}>
                        Fine Description: {data.description}
                    </Grid>
                    {data.isChargeable &&
                        <Grid item xs={12}>
                            Price: {getMoneyFormat(data.price)}
                        </Grid>
                    }
                    {data.isBannedIndefinitely ?
                        <Grid item xs={12}>
                            Banned Indefinitely
                        </Grid>
                        : 
                        <Grid item xs={12}>
                            Duration Ban: {data.durationBan && data.durationBan > 1 ? data.durationBan + "days" : data.durationBan + "day"}
                        </Grid>
                    }
                    <Grid item xs={12}>
                        Status: {data.isPaid ? 'Paid' : 'Not Paid'}
                    </Grid>

                    <Grid item xs={12}>
                        <button onClick={() => { navigate("..") }}>close</button>
                    </Grid>
                </Grid>
            </Dialog>
        </>
    );
}